export default function BuildersSlide() {
  return (
    <div className="max-w-7xl w-full mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
      <div>
        <h2 className="text-4xl font-bold mb-6">
          <span className="text-gray-500">For Builders:</span><br />
          From "Idea" to "Fund"<br />
          in <span className="text-avo-lime">Minutes</span>.
        </h2>
        <p className="text-gray-400 text-lg mb-8 leading-relaxed">
          You build the brain, Avo takes care of the rest.
          <br /><br />
          <strong className="text-white">Miles handles distribution and discovery.</strong> Your portfolio is instantly discoverable to thousands of users.
        </p>
        <div className="flex flex-col gap-3">
          <div className="flex items-center gap-3 p-3 rounded-lg bg-gray-900 border border-gray-800">
            <div className="w-2 h-2 rounded-full bg-green-500" />
            <span className="font-mono text-sm text-gray-300">On-Chain Execution</span>
          </div>
          <div className="flex items-center gap-3 p-3 rounded-lg bg-gray-900 border border-gray-800">
            <div className="w-2 h-2 rounded-full bg-green-500" />
            <span className="font-mono text-sm text-gray-300">Automated Rebalancing</span>
          </div>
          <div className="flex items-center gap-3 p-3 rounded-lg bg-gray-900 border border-gray-800">
            <div className="w-2 h-2 rounded-full bg-green-500" />
            <span className="font-mono text-sm text-gray-300">Tracking & Analytics</span>
          </div>
          <div className="flex items-center gap-3 p-3 rounded-lg bg-gray-900 border border-gray-800">
            <div className="w-2 h-2 rounded-full bg-green-500" />
            <span className="font-mono text-sm text-gray-300">Instant Liquidity via Miles</span>
          </div>
        </div>
      </div>

      {/* Code editor */}
      <div className="relative">
        <div className="absolute -inset-1 bg-gradient-to-r from-avo-lime via-avo-cyan to-avo-purple opacity-30 blur-lg rounded-xl" />
        <div className="relative bg-[#0d0d10] border border-gray-800 rounded-xl overflow-hidden shadow-2xl">
          <div className="flex items-center justify-between px-4 py-3 border-b border-gray-800 bg-[#151518]">
            <div className="flex gap-2">
              <div className="w-3 h-3 rounded-full bg-[#FF5F56]" />
              <div className="w-3 h-3 rounded-full bg-[#FFBD2E]" />
              <div className="w-3 h-3 rounded-full bg-[#27C93F]" />
            </div>
            <div className="text-xs text-gray-500 font-mono">create-index.ts</div>
            <div className="w-4" />
          </div>
          <div className="p-6 overflow-x-auto">
            <pre className="font-mono text-[13px] leading-relaxed">
              <span className="text-gray-500">{"// 1. Create your portfolio"}</span>{"\n"}
              <span className="text-purple-400">const</span>{" "}
              <span className="text-yellow-200">res</span>{" = "}
              <span className="text-purple-400">await</span>{" "}
              <span className="text-blue-400">fetch</span>{"("}<span className="text-green-400">"https://api.avo.so/api/portfolio/create"</span>{", {"}{"\n"}
              {"  method: "}<span className="text-green-400">"POST"</span>{","}{"\n"}
              {"  headers: { Authorization: "}<span className="text-green-400">`Bearer ${"{"}</span><span className="text-yellow-200">token</span><span className="text-green-400">{"}"}`</span>{" },"}{"\n"}
              {"  body: "}<span className="text-blue-400">formData</span>{"({"}{"\n"}
              {"    name: "}<span className="text-green-400">"SOL Momentum Index"</span>{","}{"\n"}
              {"    type: "}<span className="text-green-400">"INDEX_PORTFOLIO"</span>{","}{"\n"}
              {"  }),"}{"\n"}
              {"});"}{"\n"}
              <span className="text-purple-400">const</span>{" { "}
              <span className="text-yellow-200">portfolio_id</span>{" } = "}
              <span className="text-purple-400">await</span>{" res."}
              <span className="text-blue-400">json</span>{"();"}{"\n"}
              {"\n"}
              <span className="text-gray-500">{"// 2. Set target allocations"}</span>{"\n"}
              <span className="text-purple-400">await</span>{" "}
              <span className="text-blue-400">fetch</span>{"("}<span className="text-green-400">"https://api.avo.so/api/portfolio/update"</span>{", {"}{"\n"}
              {"  method: "}<span className="text-green-400">"POST"</span>{","}{"\n"}
              {"  headers: {"}{"\n"}
              {"    Authorization: "}<span className="text-green-400">`Bearer ${"{"}</span><span className="text-yellow-200">token</span><span className="text-green-400">{"}"}`</span>{","}{"\n"}
              {"    "}<span className="text-green-400">"Content-Type"</span>{": "}<span className="text-green-400">"application/json"</span>{","}{"\n"}
              {"  },"}{"\n"}
              {"  body: JSON."}<span className="text-blue-400">stringify</span>{"({"}{"\n"}
              {"    portfolio_id,"}{"\n"}
              {"    target_positions: ["}{"\n"}
              {"      { mint: "}<span className="text-green-400">"So111...112"</span>{", allocation: "}<span className="text-orange-400">0.5</span>{" },"}{" "}<span className="text-gray-600">{"// SOL"}</span>{"\n"}
              {"      { mint: "}<span className="text-green-400">"GdZ9r...smP"</span>{", allocation: "}<span className="text-orange-400">0.3</span>{" },"}{" "}<span className="text-gray-600">{"// AVO"}</span>{"\n"}
              {"      { mint: "}<span className="text-green-400">"D1wZH...BLV"</span>{", allocation: "}<span className="text-orange-400">0.2</span>{" },"}{" "}<span className="text-gray-600">{"// INFRA"}</span>{"\n"}
              {"    ],"}{"\n"}
              {"  }),"}{"\n"}
              {"});"}{"\n"}
              {"\n"}
              <span className="text-gray-500">{"// 3. That's it. Miles sells it for you."}</span>{"\n"}
              {"console."}<span className="text-blue-400">log</span>{"("}
              <span className="text-green-400">"Index is live on avo.so"</span>
              {");"}
            </pre>
          </div>
        </div>
        <p className="text-center text-sm text-gray-500 mt-4">
          <span className="text-white font-mono">docs.avo.so</span>
        </p>
      </div>
    </div>
  );
}
